import {Component} from '@angular/core';
import {UserAppState} from '../../../store/user/reducers/user.reducer';
import {Store} from '@ngrx/store';
import {selectUser} from '../../../store/user/selectors/user.selectors';

@Component({
    selector: 'app-your-data-create-proposal',
    templateUrl: './your-data-create-proposal.component.html',
    styleUrls: ['../../../../styles/standard-elements.scss'],
    standalone: false
})
export class YourDataCreateProposalComponent {

  user$ = this.userStore.select(selectUser);

  constructor(private readonly userStore: Store<UserAppState>,
  ) {
  }

}


